import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { CancelBroadbandError } from "@features/CancelBroadband/CancelBroadbandError/CancelBroadbandError";
import { ICancelBroadbandForm } from "@features/CancelBroadband/interface/ICancelBroadbandForm";
import { useCancelBroadbandDetails } from "@features/CancelBroadband/CancelBroadbandForm/CancelBroadbandDetails/useCancelBroadbandDetails";
import { useTranslation } from "react-i18next";
import { CardWithTitle } from "@common/CardWithTitle/CardWithTitle";
import { Button, Stack, Typography } from "@mui/material";
import { useDeviceType } from "@hook/useDeviceType";
import { CancelBroadbandEquipments } from "@features/CancelBroadband/CancelBroadbandForm/CancelBroadbandEquipments/CancelBroadbandEquipments";

interface IParams {
    formData: ICancelBroadbandForm;
    getTerminationRequest(): void;
}

export const CancelBroadbandDetails = (props: IParams) => {
    const { formData, getTerminationRequest } = props;
    const { t } = useTranslation(["cancelBroadband", "common"]);
    const { terminationDetails, submitTerminationRequest, error, isLoading } = useCancelBroadbandDetails({
        formData,
        getTerminationRequest,
    });
    const { isMobile } = useDeviceType();

    return (
        <HandleErrorAndLoading
            error={error}
            errorComponent={<CancelBroadbandError />}
            hideComponentWrapper
            isLoading={isLoading}
        >
            {terminationDetails && (
                <Stack alignItems="center" gap={5}>
                    <CardWithTitle title={t("cancelBroadband:details.title")}>
                        <Stack gap={3} padding={2}>
                            <Stack gap={1}>
                                <Typography color="secondary" variant="h3">
                                    {t("cancelBroadband:details.cancellationDate")}
                                </Typography>
                                <Typography color="secondary" variant="normal">
                                    {t("cancelBroadband:details.cancellation")}
                                </Typography>
                            </Stack>
                            <CancelBroadbandEquipments terminationDetails={terminationDetails} />
                        </Stack>
                    </CardWithTitle>
                    <Button color="primary" fullWidth={isMobile} variant="contained" onClick={submitTerminationRequest}>
                        {t("cancelBroadband:details.cancelBroadband")}
                    </Button>
                </Stack>
            )}
        </HandleErrorAndLoading>
    );
};
